module.exports = {"441882100":"连州镇","441882101":"星子镇","441882102":"大路边镇","441882103":"龙坪镇","441882104":"西岸镇","441882105":"保安镇","441882106":"丰阳镇","441882107":"东陂镇","441882109":"九陂镇","441882118":"西江镇","441882200":"瑶安瑶族乡","441882201":"三水瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441882.json
// module id = 1879
// module chunks = 0